import React, { useEffect, useState } from 'react';
import { useFieldArray } from 'react-hook-form';
import { Link } from 'react-router-dom';

let checkState = 0;

function PerformerList({ isMailing, setSelectApplicant, selectApplicant, isSelectApplicant, isApplicants, setOpenUser, name, form, currentItems }) {
  const userChecked = form.watch(name);
  const [allChecked, setAllChecked] = useState(false);
  const isAllChecked = (list, updateList) => {
    return list?.filter?.((item) => updateList[item.id])?.length == list?.length;
  };

  return (
    <div className="flex w-full flex-col">
      <div className="overflow-y-auto">
        <div className="p-2 min-w-full inline-block align-middle">
          <div className="border rounded-lg overflow-hidden justify-start">
            <table className=" items-center divide-y divide-gray-200 mb-20">
              <thead>
                <tr className="">
                  {!isMailing && (
                    <th width={isSelectApplicant ? '50px' : '40px'} scope="col" className=" py-3 text-start text-[16px] font-medium uppercase">
                      {isSelectApplicant ? (
                        <div></div>
                      ) : (
                        <input
                          id="select_all"
                          name="all"
                          type="checkbox"
                          aria-checked={false}
                          value={allChecked}
                          checked={allChecked}
                          className="h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500"
                          onClick={(e) => {
                            if (e.target.checked) {
                              let allChecked = {};
                              currentItems?.map((item) => {
                                allChecked = { ...allChecked, [item.id]: true };
                              });
                              form.setValue(name, { ...userChecked, ...allChecked });
                              setAllChecked(true);
                            } else {
                              currentItems?.map((item) => {
                                delete userChecked[item.id];
                              });
                              form.setValue(name, userChecked);
                              setAllChecked(false);
                            }
                          }}
                        />
                      )}
                    </th>
                  )}

                  <th width="40px" scope="col" className=" py-3 text-start text-[16px] font-medium uppercase">
                    №
                  </th>
                  <th scope="col" className=" py-3 text-start text-[16px] font-medium uppercase">
                    ФИО
                  </th>
                  {isApplicants && (
                    <th width="auto" scope="col" className="px-8 py-3 text-start text-[16px] font-medium ">
                      Статус
                    </th>
                  )}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 items-center justify-center align-middle">
                {currentItems &&
                  currentItems?.map((item) => (
                    <tr
                      key={item.id}
                      onClick={() => {
                        if (isSelectApplicant) {
                          setSelectApplicant(item.id);
                        }
                      }}
                      style={isSelectApplicant ? { cursor: 'pointer' } : {}}>
                      {!isMailing && (
                        <td className=" py-4 whitespace-nowrap text-sm text-gray-800" style={selectApplicant == item.id ? { background: 'rgba(0, 178, 164,0.2)', borderRadius: '4px  0 0 4px ' } : {}}>
                          {isSelectApplicant ? (
                            <div>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="text-gray-400 ml-3">
                                <path fill={selectApplicant == item.id ? 'rgb(0, 178, 164)' : 'rgba(156, 163, 175,0.6)'} d="m9.55 15.15l8.475-8.475q.3-.3.7-.3t.7.3t.3.713t-.3.712l-9.175 9.2q-.3.3-.7.3t-.7-.3L4.55 13q-.3-.3-.288-.712t.313-.713t.713-.3t.712.3z" />
                              </svg>
                            </div>
                          ) : (
                            <input
                              name={item.num}
                              type="checkbox"
                              aria-checked={'false'}
                              onClick={() => {}}
                              className="select_checkbox h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500"
                              defaultChecked={userChecked[item.id]}
                              checked={!!userChecked[item.id]}
                              onChange={(e) => {
                                let updateChecked;
                                if (e.target.checked) {
                                  updateChecked = { ...userChecked, [item.id]: true };
                                  form.setValue(name, updateChecked);
                                } else {
                                  delete userChecked[item.id];
                                  updateChecked = userChecked;
                                  form.setValue(name, userChecked);
                                }
                                setAllChecked(isAllChecked(currentItems, updateChecked));
                              }}
                            />
                          )}
                        </td>
                      )}

                      <td className=" py-4 whitespace-nowrap text-sm text-gray-800" style={selectApplicant == item.id ? { background: 'rgba(0, 178, 164,0.2)' } : {}}>
                        {item.id}
                      </td>
                      <td className=" py-4 whitespace-nowrap text-sm text-gray-800" style={selectApplicant == item.id ? { background: 'rgba(0, 178, 164,0.2)' } : {}}>
                        <div
                          style={{ cursor: 'pointer', display: 'inline-block' }}
                          onClick={() => {
                            setOpenUser(item.id);
                          }}>
                          {item.full_name}
                        </div>
                      </td>
                      {isApplicants && (
                        <td className="px-8 py-4 whitespace-nowrap text-sm text-gray-800" style={selectApplicant == item.id ? { background: 'rgba(0, 178, 164,0.2)', borderRadius: '  0 4px 4px 0  ' } : {}}>
                          {item?.is_active && !item?.is_blocked ? 'Активен' : !item?.is_active && !item?.is_blocked ? 'Не активен' : !item?.is_active && item?.is_blocked ? 'Заблокирован' : ''}
                        </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PerformerList;
